import { TextField } from '@mui/material'
import { withReactHookForm } from './withReactHookForm'

export const FormTextField = withReactHookForm(TextField)
export type FormTextFieldProps =
  typeof FormTextField extends React.FC<infer P> ? P : never
